import React from 'react'

export default class ResourceActionsCell extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      resource: props.resource
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render() {
    let { resource } = this.state
    return (
      <>
        <a
          href="javascript:;"
          class="btn btn-icon btn-light btn-hover-primary btn-sm ml-1"
          title="Edit"
          onClick={() => this.props.onEditPressed(resource) }
        >
          <i class="flaticon2-pen text-primary icon-sm"></i>
        </a>
      </>
    )
  }
}
